export default "__VITE_ASSET__DYsVDWrz__"